import { NgModule } from '@angular/core';
import { ErrorPageRoutingModule } from './error-page-routing.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorPageComponent } from './error-page.component';

@NgModule({
  imports: [ErrorPageRoutingModule, CommonModule, TranslateModule],
  declarations: [ErrorPageComponent],
})
export class ErrorPageModule {}
